import { useQuery } from '@tanstack/react-query';
import { useConfig } from '../default-config';
import restClient from '../util/web-http-client';
const setHeader = (bankregnr) => {
    return {
        'X-BankRegNr': bankregnr,
    };
};
export const useMarkedsrente = () => {
    const { bankregnr } = useConfig();
    return useQuery({
        queryKey: ['markedsRente'],
        queryFn: () => restClient.getMarkedsrente(setHeader(bankregnr)),
        retry: 1,
    });
};
export const useLaaneramme = (laaneramme) => {
    const { bankregnr } = useConfig();
    return useQuery({
        queryKey: [
            'maksLaaneramme',
            laaneramme.aarsinntekt,
            laaneramme.antallLaantakere,
            laaneramme.antallBarn,
            laaneramme.antallBiler,
            laaneramme.gjeld,
        ],
        queryFn: () => restClient.getLaaneramme(laaneramme, setHeader(bankregnr)),
        enabled: laaneramme.aarsinntekt > 100000 && laaneramme.antallLaantakere > 0,
    });
};
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaG9va3MuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyIuLi8uLi8uLi8uLi9zcmMvaG9va3MvaG9va3MudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBQUEsT0FBTyxFQUFFLFFBQVEsRUFBRSxNQUFNLHVCQUF1QixDQUFDO0FBRWpELE9BQU8sRUFBRSxTQUFTLEVBQUUsTUFBTSxtQkFBbUIsQ0FBQztBQUU5QyxPQUFPLFVBQVUsTUFBTSx5QkFBeUIsQ0FBQztBQUVqRCxNQUFNLFNBQVMsR0FBRyxDQUFDLFNBQTZCLEVBQWUsRUFBRTtJQUM3RCxPQUFPO1FBQ0gsYUFBYSxFQUFFLFNBQVU7S0FDNUIsQ0FBQztBQUNOLENBQUMsQ0FBQztBQUVGLE1BQU0sQ0FBQyxNQUFNLGVBQWUsR0FBRyxHQUFHLEVBQUU7SUFDaEMsTUFBTSxFQUFFLFNBQVMsRUFBRSxHQUFHLFNBQVMsRUFBRSxDQUFDO0lBQ2xDLE9BQU8sUUFBUSxDQUFDO1FBQ1osUUFBUSxFQUFFLENBQUMsY0FBYyxDQUFDO1FBQzFCLE9BQU8sRUFBRSxHQUFHLEVBQUUsQ0FBQyxVQUFVLENBQUMsZUFBZSxDQUFDLFNBQVMsQ0FBQyxTQUFTLENBQUMsQ0FBQztRQUMvRCxLQUFLLEVBQUUsQ0FBQztLQUNYLENBQUMsQ0FBQztBQUNQLENBQUMsQ0FBQztBQUVGLE1BQU0sQ0FBQyxNQUFNLGFBQWEsR0FBRyxDQUFDLFVBQXlCLEVBQUUsRUFBRTtJQUN2RCxNQUFNLEVBQUUsU0FBUyxFQUFFLEdBQUcsU0FBUyxFQUFFLENBQUM7SUFDbEMsT0FBTyxRQUFRLENBQUM7UUFDWixRQUFRLEVBQUU7WUFDTixnQkFBZ0I7WUFDaEIsVUFBVSxDQUFDLFdBQVc7WUFDdEIsVUFBVSxDQUFDLGdCQUFnQjtZQUMzQixVQUFVLENBQUMsVUFBVTtZQUNyQixVQUFVLENBQUMsV0FBVztZQUN0QixVQUFVLENBQUMsS0FBSztTQUNuQjtRQUNELE9BQU8sRUFBRSxHQUFHLEVBQUUsQ0FBQyxVQUFVLENBQUMsYUFBYSxDQUFDLFVBQVUsRUFBRSxTQUFTLENBQUMsU0FBUyxDQUFDLENBQUM7UUFDekUsT0FBTyxFQUFFLFVBQVUsQ0FBQyxXQUFXLEdBQUcsTUFBTSxJQUFJLFVBQVUsQ0FBQyxnQkFBZ0IsR0FBRyxDQUFDO0tBQzlFLENBQUMsQ0FBQztBQUNQLENBQUMsQ0FBQyJ9